import { render, staticRenderFns } from "./SalePriceListDialog.vue?vue&type=template&id=b8542bb0&scoped=true"
import script from "./SalePriceListDialog.vue?vue&type=script&lang=js"
export * from "./SalePriceListDialog.vue?vue&type=script&lang=js"
import style0 from "./SalePriceListDialog.vue?vue&type=style&index=0&id=b8542bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8542bb0",
  null
  
)

export default component.exports